<template>
  <div class="userform" :v-loading="true">
    <el-form
      class="detail-form paddingTopDetail"
      size="small"
      :model="form"
      :rules="rules"
      ref="userDetailForm"
      label-width="110px"
    >
      <div class="userform-group">
        <div class="flex-1 user-item-group">
          <el-form-item prop="account" label="用户名：">
            <el-input placeholder="请输入" v-model="form.account" :disabled="isShow"> </el-input>
          </el-form-item>
          <el-form-item prop="phoneNum" label="手机号：">
            <el-input placeholder="请输入" v-model="form.phoneNum" :disabled="isShow"> </el-input>
          </el-form-item>
          <el-form-item prop="userType" label="用户类型：">
            <el-select v-model="form.userType" :disabled="isShow">
              <el-option v-for="item in userTypeList" :key="item.value" :value="item.value" :label="item.label"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="roleId" label="角色：">
            <el-select v-model="form.roleId" :disabled="isShow">
              <el-option v-for="item in roleList" :key="item.id" :value="item.id" :label="item.name"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="plainPassword" label="密码：">
            <el-input
              class="txtPassword"
              v-model="form.plainPassword"
              :placeholder="userInfo.id > 0 ? '不修改密码请留空' : '请输入'"
              :disabled="isShow"
            >
            </el-input>
          </el-form-item>
          <el-form-item prop="confirmPassword" label="确认密码：">
            <el-input
              class="txtPassword"
              v-model="form.confirmPassword"
              :placeholder="userInfo.id > 0 ? '不修改密码请留空' : '请输入'"
              :disabled="isShow"
            >
            </el-input>
          </el-form-item>
          <el-form-item prop="realName" label="真实姓名：">
            <el-input placeholder="请输入" v-model="form.realName" :disabled="isShow"> </el-input>
          </el-form-item>
          <el-form-item label="使用状态：">
            <el-switch 
              v-model="form.status" 
              :disabled="isShow" 
              :active-value="1"
              :inactive-value="2"
              active-text="开启"
              inactive-text="禁用"
            ></el-switch>
            <!-- <el-radio-group v-model="form.status" :disabled="isShow">
              <el-radio :label="1">开启</el-radio>
              <el-radio :label="2">禁用</el-radio>
            </el-radio-group> -->
          </el-form-item>
          <el-form-item v-if="showNationSel" class="width-100" prop="location" label="管辖区域：">
            <el-checkbox v-if="canCheckNationwide" class="margin-bottom-10" v-model="isNationwide" label="全国" :disabled="isShow"></el-checkbox>
            <AreaCascader v-if="!isNationwide" v-model="form.location" :end-level="4" :disabled="isShow" checkStrictly :clearable="false" :initArea="[area]" />
          </el-form-item>
        </div>
      </div>

      <div v-if="!isShow" style="text-align: center; margin: 20px 0">
        <span>
          <el-button class="submit-btn" :loading="submitLoading" @click="submitForm">提交</el-button>
          <el-button class="cancel-btn" @click="resetForm">重置</el-button>
        </span>
      </div>
    </el-form>
  </div>
</template>
<script>
import mixin from './userFormJS'
import AreaCascader from '@/components/common/areaCascader'

export default {
  name: 'userForm',
  mixins: [mixin],
  data() {
    return {
      area: JSON.parse(localStorage.getItem('user')).area,
    }
  },
  props: {
    userInfo: {
      type: Object,
      default: () => ({})
    },
    addModal: {
      type: Boolean,
      default: false,
    },
    showType: {
      type: String,
      default: 'showUser'
    },
    roleList: {
      type: Array,
      default: []
    },
    userTypeList: {
      type: Array,
      default: []
    }
  },
  components: { AreaCascader },
}
</script>
<style lang="less" scoped>
.user-item-group {
  display: flex;
  flex-wrap: wrap;
  .el-form-item {
    width: 50%;
  }
  .el-form-item.width-100 {
    width: 100%;
  }
  .el-select {
    width: 100%;
  }
  :deep(.el-cascader) {
    width: 100%;
  }
  .select-group /deep/ .block {
    width: 100%;
  }
}
.el-cascader {
  width: 100%;
}
.upload-input.userUpload /deep/ .el-upload-dragger {
  width: 70%;
  height: 190px;
}
.width-100 {
  width: 100%;
}
.margin-bottom-10 {
  margin-bottom: 10px;
}
</style>
<style lang="less">
.txtPassword {
  -webkit-text-security: disc;
}
.userform.el-checkbox {
  max-width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 10px;
}
</style>
